import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 }, cycleCount: { type: Number, default: 5 } }
  static targets = ["text"]

  connect() {
    this.originalText = this.textTarget.textContent
    this.startInterval()
  }

  disconnect() {
    if (this.intervalId) clearInterval(this.intervalId)
  }

  startInterval() {
    this.intervalId = setInterval(() => {
      this.cycleText()
    }, this.intervalValue || 2000)
  }

  cycleText() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*"
    const finalText = this.generateRandomText()
    let cycleCount = 0
    
    const cycleInterval = setInterval(() => {
      if (cycleCount >= this.cycleCountValue) {
        this.textTarget.textContent = finalText
        clearInterval(cycleInterval)
        
        this.cycleBackToOriginal()
        return
      }
      
      this.textTarget.textContent = this.generateRandomText()
      cycleCount++
    }, 100)
  }

  cycleBackToOriginal() {
    let cycleCount = 0
    
    const cycleInterval = setInterval(() => {
      if (cycleCount >= this.cycleCountValue) {
        this.textTarget.textContent = this.originalText
        clearInterval(cycleInterval)
        return
      }
      
      this.textTarget.textContent = this.generateRandomText()
      cycleCount++
    }, 100)
  }

  generateRandomText() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*"
    let randomized = ""
    for (let i = 0; i < this.originalText.length; i++) {
      const char = this.originalText[i]
      if (char === " ") {
        randomized += " "
      } else {
        randomized += chars.charAt(Math.floor(Math.random() * chars.length))
      }
    }
    return randomized
  }
}
